import * as React from 'react'
import * as convertTime from 'utils/convert-time'
import * as T from 'components/ui/typography'

import Router from 'next/router'
import OutlinedBox from 'components/shared/outlined-box'
import ErrorDialog from 'components/shared/error-dialog'
import Routes from 'utils/routes'

import Button from 'components/shared/button'
import NoCreditDialog from 'components/shared/credit-dialog'
import UseCreditsCheck from 'hooks/credits/use-credits-check'
import { Clock4, Info } from 'lucide-react'
import { analytics } from 'utils/analytics'
import TestyEnv from 'components/shared/test-envs/testy'
import TestyTOLCEnv from 'components/shared/test-envs/testy-tolc'

interface LiveSimCardProps {
    numberOfLiveSim?: number
    liveSim: ExamSimulation
}
const LiveSimulationCard = React.memo<LiveSimCardProps>(({ numberOfLiveSim, liveSim }) => {
    const isSmall = numberOfLiveSim && numberOfLiveSim > 2
    const startDate = new Date(liveSim.available_from)
    const endingDate = new Date(startDate.getTime() + (liveSim.duration || 0) * 1000)
    const { simCreditsCheck } = UseCreditsCheck()

    const [showZeroCreditDialog, setShowZeroCreditDialog] = React.useState<boolean>(false)
    const [showOutOfTimeDialog, setShowOutOfTimeDialog] = React.useState<boolean>(false)

    const handleCreateSim = () => {
        if (!simCreditsCheck()) {
            setShowZeroCreditDialog(true)
        } else handleCreateLiveSim()
    }

    const handleCreateLiveSim = () => {
        if (endingDate.getTime() > Date.now()) {
            analytics.track('new_live_simulation')
            Router.push('/new', {
                pathname: Routes.NewSimulation,
                query: {
                    simulationId: liveSim._id,
                    fetchingMode: 'CREATE',
                    category: liveSim.category,
                    endTime: endingDate.getTime(),
                },
            })
        } else setShowOutOfTimeDialog(true)
    }

    return (
        <OutlinedBox
            className="p-6 flex !rounded-lg justify-between"
            style={{ flexDirection: isSmall ? 'column' : 'row' }}>
            <div className="flex" style={{ flexDirection: isSmall ? 'column-reverse' : 'column', flex: 1 }}>
                <div className="mb-4">
                    <T.Small className="mb-1">{liveSim.name}</T.Small>
                    <T.Muted>Piccola descrizione della simulazione live</T.Muted>
                </div>
                <div
                    className="flex rounded-sm items-center self-start bg-primary p-[4px] rounded-xs gap-1 "
                    style={{
                        marginBottom: isSmall ? 2 : 0,
                    }}>
                    <Info className="text-neutral-100" />
                    <T.Small className="text-white mr-2">Live in questo momento</T.Small>
                </div>
            </div>
            <div className="flex flex-col items-start justify-between">
                <div
                    className="flex items-center rounded-sm justify-between border p-1 gap-1"
                    style={{
                        margin: isSmall ? '8px 0' : 0,
                    }}>
                    <Clock4 style={{ fontSize: 24, marginTop: -0.1 }} />
                    <T.Muted>
                        <>
                            {' '}
                            Fino alle {convertTime.padTo2Digits(endingDate.getHours() % 24)}:
                            {convertTime.padTo2Digits(endingDate.getMinutes() % 60)}
                        </>
                    </T.Muted>
                </div>
                <Button onClick={() => handleCreateSim()}>Inizia Subito</Button>
            </div>
            <NoCreditDialog trigger={<></>} open={showZeroCreditDialog} />
            <ErrorDialog
                trigger={<></>}
                backFnc={() => setShowOutOfTimeDialog(false)}
                title="Ooops"
                description="sembra che questa simulazione sia già scaduta, ricarica la pagina"
                buttonText="ho capito"
                open={showOutOfTimeDialog}
            />
        </OutlinedBox>
    )
})
export default LiveSimulationCard
